<style lang="less" scoped>
.imgArrayGN {width: 1200px;margin-bottom: 50px;
  .ulbox {margin: 0;padding: 0;list-style: none;display: flex;justify-content: space-between;align-items: center;
    .libox {width: 259px;height: 379px;
      .tlt {height: 46px;display: flex;justify-content: space-between;align-items: center;
        .imgicon {width: 52px;height: 46px;
          img {width: 100%;height: 100%;}}
        .titlespan {display: inline-block;margin: 14px auto;text-align: left;	font-family: AlibabaPuHuiTi-Bold;font-size: 15px;font-weight: normal;font-stretch: normal;line-height: 20px;letter-spacing: 1px;color: #2c3e50;cursor: pointer;}}
      .imgbox {width: 259px;height: 160px;cursor: pointer;
        img {width: 100%;height: 100%;display: block;border: 1px solid;}}
      .titleBox {width: 100%;height: 130px;font-family: AlibabaPuHuiTi-Medium;font-size: 16px;font-weight: normal;font-stretch: normal;line-height: 24px;letter-spacing: 1px;color: #2c3e50;cursor: pointer;
        p {margin: 10px 16px;text-align: left;	font-family: AlibabaPuHuiTi-Medium;font-size: 16px;font-weight: normal;font-stretch: normal;line-height: 24px;letter-spacing: 1px;color: #2c3e50;}}
      .foot {margin: 0px 16px;list-style: none;display: flex;justify-content: space-between;align-items: center;cursor: pointer;
        .updatetime {font-family: AlibabaPuHuiTi-Regular;font-size: 12px;font-weight: normal;font-stretch: normal;line-height: 24px;letter-spacing: 1px;color: #2c3e50;}
        .details {font-family: AlibabaPuHuiTi-Bold;font-size: 12px;font-weight: normal;font-stretch: normal;line-height: 24px;letter-spacing: 1px;color: #0d7ffc;
          img {width: 12px;height: 12px;    position: relative;top: 2px;}
        }
      }
    }
  }
}
</style>

<!--安进 2021.6.30 矿业项目组件-->
<template>
  <div class="imgArrayGN">
    <ul class="ulbox">
      <li class="libox" v-for="(item, index) in Mining" :key="index">
        <div class="tlt">
          <span class="titlespan">{{ item.title }}</span>
        </div>
        <div class="imgbox">
          <img :src="item.thumb" alt="" />
        </div>
        <div class="titleBox">
          <p>{{ item.content }}</p>
        </div>
        <div class="foot">
          <span class="updatetime">更新时间：{{(item.time * 1000) | formatDate()}}</span>
          <span class="details" @click="handclick(item)">详情<img src="static/images/zlkindex/arrow.png" alt=""></span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import filters from '../method/filter.js'
export default {
  props: ['Mining'],
  name: '',
  mixins: [filters],
  data()
  {
    return {
      //矿业项目数据
      mining: []
    }
  },
  methods: {
    handclick(item)
    {
      this.$emit('handclick', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/MiningPproject.vue